import React, { useEffect, useRef, useState } from 'react'
import List from '@material-ui/core/List'
import { useRest } from '../../contexts/rest/use'
import { useConfig } from '../../contexts/config/use'
import { QueueListItem } from './queue_listitem'
import { RedirectButton } from './redirectbutton'
import { Header } from '../header'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useTranslation } from '../../contexts/i18n/use'
import CircularProgress from '@material-ui/core/CircularProgress'
import { QueueEmptyListItem } from './queue_emptylistitem'
import { useHistory } from "react-router-dom"
import { isFalsyOrEmpty } from '../helpers/object'
import { TicketFailureModal } from './ticketfailuremodal'
import { Queuedata } from '../../services/dto/queuedata.dto'
import { ClearOutdatedStorage } from '../helpers/clearstorage'
import { QueueCheckinItem } from './queue_checkin'

export const QueueDisplay = () => {
  const { state: { selectedoffice, queues, wasticketfailure }, actions: { handleTakeTicket, qrToQueueSelection } } = useRest();
  const { state: { config }, actions: {GetOfficeIDFromUrlID, CheckIfHasForm, ReloadConfiguration, IsOfficeActive, ShouldShowTicketInfo, GetCheckinData, IsOpen }} = useConfig();
  const [disablebuttons, setDisableButtons] = useState(false);
  const [officeid, setOfficeID] = useState();
  const [content, setContent] = useState();
  const sneakySoundRef = useRef();
  const [failure, setFailure] = useState(null);
  const [hasloaded, setHasLoaded] = useState(false);
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (config)
    {
      sessionStorage.removeItem("formdata");

      var oldbaseurl = localStorage.getItem("baseurl");
      if (window.location.pathname !== oldbaseurl)
      {
        setHasLoaded(false);
        ClearOutdatedStorage();
        localStorage.setItem("baseurl", window.location.pathname);
        ReloadConfiguration();
        window.location.reload();
        return;
      }

      const savedticket = JSON.parse(localStorage.getItem("ticket"));
      if (!isFalsyOrEmpty(savedticket) && !savedticket.cancelled)
        history.push("ticket");
      else
      {
        const urlid = GetOfficeIDFromHash();
        if(urlid)
        {
          const result = GetOfficeIDFromUrlID(urlid);
          if (!result)
            history.push("404")
          else
            setOfficeID(result);
        }
        else
        {
          const oid = localStorage.getItem("selectedoffice");
          if (!oid)
            history.push("404")
        }
      }
      setHasLoaded(true);
    }
  },[config])

  useEffect(() => {
    if (officeid)
    {
      if (IsOfficeActive(officeid))
      {
        var hash = window.location.hash.split("?")
        window.history.replaceState({}, '', window.location.origin + window.location.pathname + hash[0])
        qrToQueueSelection(officeid);
      }
      else
      {
        localStorage.removeItem("selectedoffice");
        history.push("404");
      }
    }
  }, [officeid])

  useEffect(() => {
    if (wasticketfailure)
      setFailure(true);
    else 
      setFailure(null);
  },[wasticketfailure])

  useEffect(() => {
    if (config) 
    {
      const checkindata = GetCheckinData(selectedoffice);
      let checkinitem = null;
      let queueitems = null;

      if (!isFalsyOrEmpty(queues) && queues.length > 0)
      {
        queueitems = queues.map((x,i) => { return <QueueListItem key={"QLItem_" + i} 
        queuedata={x}
        officeID={selectedoffice} 
        bookTicket={handleTakeTicket}
        hasform={CheckIfHasForm(selectedoffice, new Queuedata(x.queueID, "", ""))}
        disabled={disablebuttons}
        disablecallback={handleDisable}
        showPeopleAhead={ShouldShowTicketInfo("peopleahead", x.queueID)}
        showWaitingTime={config.showWaitingTimeInQueuelist}
        enableSneakySound={PlaySneakySound}
        /> });
      }

      if (!isFalsyOrEmpty(checkindata) && checkindata.isActive && IsOpen(checkindata))
      {
        checkinitem = <QueueCheckinItem 
                              key={"CheckinItem"}
                              officeID={selectedoffice} 
                              disabled={disablebuttons}
                              disablecallback={handleDisable}
                              enableSneakySound={PlaySneakySound}
                            />
      }

      if (!isFalsyOrEmpty(checkinitem) && !isFalsyOrEmpty(queueitems))
      {
        const newcontent = [checkinitem].concat(queueitems);
          setContent(newcontent);
      }
      else if (!isFalsyOrEmpty(queueitems))
        setContent(queueitems);
      else if (!isFalsyOrEmpty(checkinitem))
        setContent(checkinitem)
      else
        setContent(<QueueEmptyListItem/>);  
    }
    else 
      setContent(<QueueEmptyListItem/>);
  }, [queues])

  const GetOfficeIDFromHash = () => {
    if ( window.location.hash && Object.keys(window.location.hash).length > 0)
    {
      var hashpath = window.location.hash.substr(1);
      var queryparams = hashpath.split('?');
      if (queryparams && queryparams.length > 1)
      {
        var result = queryparams[1].split('=');
        if (result[0] === "officeID")
          return result[1];
        else
          return null;
      }
    }
  }

  const handleDisable = value => {
    setDisableButtons(value);
  }

  const PlaySneakySound = () => {
    if (config && config.playSound)
    {
      var playPromise = sneakySoundRef.current.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => {
        })
        .catch(error => {
          console.error(error)
        });
      }
    }
  }

  if ((disablebuttons && !wasticketfailure) || !hasloaded)
  {
    return (
      <div className={classes.spinnerwrapper}>
        <CircularProgress className={[classes.spinner, "Spinner"].join(' ')} />
      </div>
    )
  }
  else
  {
    return (
      <div className={classes.container}>
        <Header />
        <div className={classes.outerbox}>
          <div className={classes.innerbox}>
            {
              !isFalsyOrEmpty(config) 
              ? 
              <List className={classes.list}>
                { content }
              </List>
              : <CircularProgress className={[classes.spinner, "Spinner"].join(' ')} id="queue-spinner"/>
            }
            { failure ? <TicketFailureModal disablecallback={handleDisable}/> : <></>}
            <div className={classes.buttonwrapper}>
              { (config && config.shouldHaveRedirectButton) ? <RedirectButton url={config.redirectionLink} text={t('queuepage.redirectbuttontext')} /> : <span/> }
            </div>
            <audio ref={sneakySoundRef} id="audio" muted={true} preload="auto" src={config.soundFilePath} type="audio/mpeg"></audio>
          </div>
        </div>
      </div>
    )
  }
}

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: '1 0 auto',
  },
  outerbox: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
    overflow: 'auto'
  },
  innerbox: {
    display: 'flex', 
    flexDirection: 'column', 
    flex: '1 0 auto', 
    height: '100%'
  },
  buttonwrapper: {
    marginTop: 'auto',
    marginBottom: '1rem',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 0.5rem'
  },
  spinner: theme => ({
    color: theme.palette.primary.main,
    height: '80%',
    width: '80%'
  }),
  spinnerwrapper: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
})
